import { type ProspectDto, ProspectsService } from '@api'
import { useInfiniteQuery } from 'react-query'

import { handleError } from '@/utils/error'
import { usePagination } from '@/utils/pagination/pagination-context'

export const useProspects = () => {
  const {
    searchQuery,
    sorting,
    pagination: { pageIndex, pageSize },
  } = usePagination()

  const { id, desc } = sorting?.[0] || {}
  const query = useInfiniteQuery(
    ['prospects', searchQuery, pageIndex, pageSize, id, desc],
    () =>
      ProspectsService.findAllProspects({
        search: searchQuery,
        page: pageIndex,
        size: pageSize,
        sortBy: id,
        direction: desc ? 'desc' : 'asc',
      }),
    {
      cacheTime: 0,
      onError: (error) => {
        handleError(error, 'Failed to fetch prospects')
      },
    },
  )

  return {
    isLoading: query.isLoading,
    pageCount: query.data?.pages[0].totalPages || 0,
    prospects: (query.data?.pages.flatMap((page) => page.content) ||
      []) as ProspectDto[],
  }
}
